<template>
  <footer>
    <b-button class="back view-desktop" tag="router-link" :to="backButtonPath">
      {{ $t('botoes.voltar') }}
    </b-button>
    <b-button
      class="back-mobile view-mobile"
      tag="router-link"
      :to="backButtonPath"
    >
      {{ $t('botoes.voltar') }}
    </b-button>
    <button
      class="button button-primary emit"
      type="submit"
      @click="$emit('go-to')"
      :disabled="disabled"
      v-if="okPage && lastComp && !finalPage"
    >
      {{ $t('botoes.enviar') }}
    </button>
    <button
      class="button button-secondary emit"
      type="submit"
      @click="$emit('next-step')"
      :disabled="disabled"
      v-else-if="!lastComp && multComp && okPage"
    >
      {{ $t('botoes.continuar') }}
    </button>
    <span v-else />
  </footer>
</template>

<script>
export default {
  name: 'FormFooter',
  props: {
    disabled: {
      type: Boolean,
      default: null
    },
    finalPage: {
      type: Boolean,
      default: false
    },
    okPage: {
      type: Boolean,
      default: null
    },
    lastComp: {
      type: Boolean,
      default: false
    },
    multComp: {
      type: Boolean,
      default: false
    },
    backButtonPath: {
      type: Object,
      default: () => ({
        name: 'Documentos'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/styleguide';
@import '~@/assets/stylesheets/icons';
@import '~@/assets/stylesheets/buttons';
footer {
  position: relative;
  // background: linear-gradient(180deg, rgba(255, 255, 255, 0.74) 0, $white 100%);

  background-color: var(--bg-color-primary);
  min-height: 6.25rem;
  margin: 1rem 0;
  .button[type='submit'],
  .button {
    max-width: 10rem;
    margin-right: 2.9rem;
    margin-top: 2rem;
    &.emit:after {
      font-family: 'icomoon' !important;
      font-style: normal;
      font-weight: normal;
      font-variant: normal;
      text-transform: none;
      line-height: 1;
      content: '\e91b';
      font-size: 1.5rem;
      position: absolute;
      right: 1rem;
    }
    &.back {
      left: 2.9rem;
      background: transparent;
      position: absolute;
      max-width: 14rem;

      color: var(--light-blue);
      border: 0.05rem solid $light-blue;
      border-color: var(--light-blue);
      border-radius: 0.25rem;
      box-shadow: none;
      &:after {
        position: absolute;
        font-family: 'icomoon' !important;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        content: '\E916';
        font-size: 1.5rem;
        left: 0;
      }
    }
    &.back-mobile {
      background: transparent;
      position: absolute;

      color: var(--light-blue);
      border-radius: 0.25rem;
      box-shadow: none;
      margin-left: 2.9rem;
      padding-top: 0.5rem;
    }
  }
}
</style>
